var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiBrCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.582,8.461c.573.597.555,1.547-.043,2.121l-4.605,4.424c-.668.659-1.552.989-2.438.989s-1.774-.33-2.451-.991l-1.547-1.388c-.616-.554-.667-1.502-.113-2.118.554-.615,1.5-.668,2.119-.113l1.592,1.43c.237.23.555.232.746.042l4.62-4.438c.597-.574,1.545-.557,2.121.042Zm6.418,3.539c0,6.617-5.383,12-12,12S0,18.617,0,12,5.383,0,12,0s12,5.383,12,12Zm-3,0c0-4.962-4.037-9-9-9S3,7.038,3,12s4.037,9,9,9,9-4.038,9-9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiBrCheckCircle);
export default __webpack_public_path__ + "static/media/fi-br-check-circle.807c4277d3e86f535124c796467f5698.svg";
export { ForwardRef as ReactComponent };